import InfoSignatureStep1FormComponent from '../../components/info-signature/InfoSignatureStep1FormComponent';

export default function InfoSignatureStep1Bloc() {

      return (
        <div className="">
          <div className="">
            <h2 className="card-title bleu">Veuillez saisir le code d'authentification reçu par sms </h2>
             <InfoSignatureStep1FormComponent />
          </div>
        </div>
      )
}